module.exports = __webpack_public_path__ + "static/media/the-urban-farm-sending-meals-to-children.a9e1c96b.jpg";